
// import { GoogleMap, useLoadScript } from "@react-google-maps/api";
// import { base_url } from "Backend/api";
// import { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const libraries = ["places"];
// const DEFAULT_LOCATION = { lat: 33.5138, lng: 36.2765 }; 

// export default function AddAddressMap() {
//   const { isLoaded } = useLoadScript({
//     googleMapsApiKey: "AIzaSyCRONPbA3ejLC8sfcp8TZ6h3FFm6s2dyow",
//     libraries,
//   });

//   const mapRef = useRef(null);
//   const searchRef = useRef(null);
//   const fetchTimeout = useRef(null);

//   const [center, setCenter] = useState(DEFAULT_LOCATION);
//   const [address, setAddress] = useState("جاري تحديد العنوان...");
//   const [showModal, setShowModal] = useState(false);

//   // تفاصيل العنوان
//   const [province, setProvince] = useState("");
//   const [city, setCity] = useState("");
//   const [district, setDistrict] = useState("");
//   const [street, setStreet] = useState("");
//   const [building, setBuilding] = useState("");
//   const [apartment, setApartment] = useState("");
//   const [receiver, setReceiver] = useState("");
//   const [phone, setPhone] = useState("");
//   const [fullAddress, setFullAddress] = useState("");
//    const navigate = useNavigate();

//   const fetchAddress = async (lat, lng) => {
//     try {
//       const res = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=ar&key=AIzaSyCRONPbA3ejLC8sfcp8TZ6h3FFm6s2dyow`
//       );
//       const data = await res.json();
//       if (data.status === "OK") {
//         setAddress(data.results[0].formatted_address);
//       } else {
//         setAddress(data.status);
//       }
//     } catch (e) {
//       console.log(e);
//       setAddress("error");
//     }
//   };

//   const onIdle = () => {
//     if (!mapRef.current) return;
//     const c = mapRef.current.getCenter();
//     const lat = c.lat();
//     const lng = c.lng();
//     setCenter({ lat, lng });

//     if (fetchTimeout.current) clearTimeout(fetchTimeout.current);
//     fetchTimeout.current = setTimeout(() => fetchAddress(lat, lng),100);
//   };

//   useEffect(() => {
//     if (!isLoaded) return;
//     const autocomplete = new window.google.maps.places.Autocomplete(searchRef.current);
//     autocomplete.addListener("place_changed", () => {
//       const place = autocomplete.getPlace();
//       if (!place.geometry) return;
//       const location = place.geometry.location;
//       mapRef.current.panTo({ lat: location.lat(), lng: location.lng() });
//       mapRef.current.setZoom(16);
//       fetchAddress(location.lat(), location.lng());
//     });
//   }, [isLoaded]);

//   useEffect(() => {
//     if (!navigator.geolocation) {
//       fetchAddress(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng);
//       return;
//     }
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
//         setCenter(userLocation);
//         fetchAddress(userLocation.lat, userLocation.lng);
//       },
//       () => {
//         setCenter(DEFAULT_LOCATION);
//         fetchAddress(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng);
//       }
//     );
//   }, []);

//   const handleSubmit = async () => {
//     if (!province || !city || !district || !street || !fullAddress) {
//   alert("من فضلك أكمل جميع الحقول المطلوبة");
//   return;
// }
//   const payload = {
//   description: address,
//   map_location: `${center.lat},${center.lng}`,
//   province: province,
//   city: city,
//   district: district,
//   street: street,
//   building_number: building,
//   apartment_number: apartment,
//   receiver_name: receiver,
//   receiver_phone: phone,
//   is_active: true,
//   full_address: fullAddress,
// };

//   try {
//     const token = localStorage.getItem("token");
//     const res = await fetch(`${base_url}/api/addresses`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//        Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();
//     console.log("تم الإرسال:", data);

//     if(res.ok){
//       alert("تم إضافة العنوان بنجاح!");
//       setShowModal(false); // تقفل المودال
//       navigate('/my-addresses');
//     } else {
//       alert("حصل خطأ: " + data.message);
//     }
//   } catch (error) {
//     console.log(error);
//     alert("حدث خطأ في الاتصال بالباك إند");
//   }
// };

//   if (!isLoaded) return <div>Loading...</div>;

//   return (
//     <div className="h-screen  w-full max-w-3xl mx-auto relative">
//       <GoogleMap
//         zoom={16}
//         center={center}
//         mapContainerClassName="w-full h-full"
//         onLoad={(map) => (mapRef.current = map)}
//         onIdle={onIdle}
//         options={{ disableDefaultUI: true }}
//       />

//       {/* 📍 PIN ثابت */}
//       <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full">
//         <img src="/assets/images/pin.svg" className="w-10 h-10" />
//       </div>

//       {/* 🔍 SEARCH */}
//       <input
//         ref={searchRef}
//         type="text"
//         placeholder="عما تبحث ؟"
//         className="absolute top-4 left-4 right-8 p-2 rounded-[29px] shadow border-none bg-[#F2F2F2]"
//       />

//       {/* 🧾 ADDRESS */}
//       <div className="absolute bottom-20 left-4 right-4 bg-white p-3 rounded shadow text-center text-sm font-[cairo]">
//         {address}
//       </div>

//       {/* 🔴 BUTTON */}
//       <button
//         onClick={() => setShowModal(true)}
//         className="absolute font-[cairo] bottom-4 left-4 right-4 bg-[#F93209] text-white p-3 rounded-[4px]"
//       >
//         متابعة
//       </button>

//       {/* 🔵 Bottom Sheet Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end z-50">
//           <div className="bg-white w-full rounded-t-2xl p-4 max-h-[80vh] overflow-auto">
//             <h2 className="text-center font-bold mb-4 text-[16px] font-[cairo]">أكمل العنوان</h2>

//             <div className="grid grid-cols-2 gap-2 font-[cairo] ">
//               <input value={province} onChange={(e) => setProvince(e.target.value)} placeholder="المحافظة" className="border p-2 rounded text-[12px]" />
//               <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="المدينة" className="border p-2 rounded text-[12px]" />
//               <input value={district} onChange={(e) => setDistrict(e.target.value)} placeholder="الحي" className="border p-2 rounded text-[12px]" />
//               <input value={street} onChange={(e) => setStreet(e.target.value)} placeholder="الشارع" className="border p-2 rounded text-[12px]" />
//               <input value={building} onChange={(e) => setBuilding(e.target.value)} placeholder="رقم البناء" className="border p-2 rounded text-[12px]" />
//               <input value={apartment} onChange={(e) => setApartment(e.target.value)} placeholder="رقم الشقة" className="border p-2 rounded text-[12px]" />
//               <input value={receiver} onChange={(e) => setReceiver(e.target.value)} placeholder="اسم المستلم" className="border p-2 rounded text-[12px]" />
//               <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="رقم الهاتف" className="border p-2 rounded text-[12px]" />
//             </div>

//             <textarea
//               value={fullAddress}
//               onChange={(e) => setFullAddress(e.target.value)}
//               placeholder="العنوان بالتفصيل"
//               className="border p-2 rounded w-full mt-2 font-[cairo] text-[12px]"
//               rows={3}
//             />

//             <button
//               onClick={handleSubmit}
//               className="bg-[#F93209] font-[cairo] text-white w-full mt-3 p-2 rounded"
//             >
//               إضافة
//             </button>

//             <button
//               onClick={() => setShowModal(false)}
//               className="font-[cairo] text-gray-500 w-full mt-2 p-2 rounded"
//             >
//               إلغاء
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { base_url } from "Backend/api";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AppSpinner from "components/ui/AppSpinner";
import Icon from "components/AppIcon";
import { validatePhoneNumber } from "utils/validatePhoneNumber";
import { addressListFromApi } from "utils/addressListFromApi";

const libraries = ["places"];
const DEFAULT_LOCATION = { lat: 33.5138, lng: 36.2765 };

function getAddressComponent(components, preferredTypes) {
  if (!Array.isArray(components)) return "";

  for (const type of preferredTypes) {
    const match = components.find((component) =>
      Array.isArray(component?.types) && component.types.includes(type)
    );
    if (match?.long_name) {
      return match.long_name;
    }
  }

  return "";
}

function extractAddressFields(result) {
  const components = result?.address_components || [];

  return {
    province: getAddressComponent(components, ["administrative_area_level_1"]),
    city: getAddressComponent(components, [
      "locality",
      "administrative_area_level_2",
    ]),
    district: getAddressComponent(components, [
      "sublocality_level_1",
      "sublocality",
      "neighborhood",
      "administrative_area_level_3",
    ]),
    street: getAddressComponent(components, ["route"]),
  };
}

function validateReceiverName(value) {
  const trimmed = value == null ? "" : String(value).trim();
  if (trimmed.length === 0) {
    return "اسم المستلم مطلوب";
  }
  if (trimmed.length < 3) {
    return "اسم المستلم يجب أن يكون 3 أحرف على الأقل";
  }
  return null;
}

export default function AddAddressMap() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCRONPbA3ejLC8sfcp8TZ6h3FFm6s2dyow",
    libraries,
  });

  const mapRef = useRef(null);
  const searchRef = useRef(null);
  const fetchTimeout = useRef(null);
  const lastLocation = useRef(null);

  const [center, setCenter] = useState(DEFAULT_LOCATION);
  const [address, setAddress] = useState("جاري تحديد العنوان...");
  const [showModal, setShowModal] = useState(false);

  // تفاصيل العنوان
  const [addressName, setAddressName] = useState("");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [street, setStreet] = useState("");
  const [building, setBuilding] = useState("");
  const [apartment, setApartment] = useState("");
  const [receiver, setReceiver] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [resolvedAddressFields, setResolvedAddressFields] = useState({
    province: "",
    city: "",
    district: "",
    street: "",
  });

  const navigate = useNavigate();
  const manualInputClass =
    "w-full rounded-[8px] border border-[#A8A8A8] px-4 py-2 text-right text-[13px] outline-none ring-0 shadow-none focus:border-[#F93209] focus:outline-none focus:ring-0 focus:shadow-none focus-visible:outline-none";

  const digitsOnly = (raw) => String(raw ?? "").replace(/\D/g, "");

  const fetchAddress = async (lat, lng) => {
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=ar&key=AIzaSyCRONPbA3ejLC8sfcp8TZ6h3FFm6s2dyow`
      );
      const data = await res.json();

      if (data.status === "OK") {
        const primaryResult = data.results?.[0];
        if (primaryResult) {
          setAddress(primaryResult.formatted_address || "");
          setResolvedAddressFields(extractAddressFields(primaryResult));
        } else {
          setAddress("تعذر تحديد العنوان");
          setResolvedAddressFields({
            province: "",
            city: "",
            district: "",
            street: "",
          });
        }
      } else {
        setAddress(data.status);
      }
    } catch (e) {
      console.log(e);
      setAddress("error");
    }
  };

  const handleMapStop = () => {
    if (!mapRef.current) return;

    const c = mapRef.current.getCenter();
    const lat = c.lat();
    const lng = c.lng();

    // لو نفس المكان → متعملش request
    if (
      lastLocation.current &&
      Math.abs(lastLocation.current.lat - lat) < 0.0001 &&
      Math.abs(lastLocation.current.lng - lng) < 0.0001
    ) {
      return;
    }

    lastLocation.current = { lat, lng };

    if (fetchTimeout.current) clearTimeout(fetchTimeout.current);

    fetchTimeout.current = setTimeout(() => {
      fetchAddress(lat, lng);
    }, 500); // debounce
  };

  useEffect(() => {
    if (!isLoaded) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchRef.current
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();

      mapRef.current.panTo({ lat, lng });
      mapRef.current.setZoom(16);

      lastLocation.current = { lat, lng };
      fetchAddress(lat, lng);
    });
  }, [isLoaded]);

  useEffect(() => {
    if (!navigator.geolocation) {
      fetchAddress(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        setCenter(userLocation);
        lastLocation.current = userLocation;
        fetchAddress(userLocation.lat, userLocation.lng);
      },
      () => {
        setCenter(DEFAULT_LOCATION);
        lastLocation.current = DEFAULT_LOCATION;
        fetchAddress(DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng);
      }
    );
  }, []);

  const handleOpenManualForm = () => {
    setProvince(resolvedAddressFields.province || "");
    setCity(resolvedAddressFields.city || "");
    setDistrict(resolvedAddressFields.district || "");
    setStreet(resolvedAddressFields.street || "");
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!province || !city || !district || !street || !fullAddress) {
      toast.error("من فضلك أكمل جميع الحقول المطلوبة");
      return;
    }

    const receiverValidationError = validateReceiverName(receiver);
    if (receiverValidationError) {
      toast.error(receiverValidationError);
      return;
    }

    const phoneValidationError = validatePhoneNumber(phone);
    if (phoneValidationError) {
      setPhoneError(phoneValidationError);
      toast.error(phoneValidationError);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const mapLocationSource = lastLocation.current || center;

      const listResponse = await fetch(`${base_url}/api/addresses`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const listJson = await listResponse.json().catch(() => ({}));
      const existingAddresses = addressListFromApi(listJson?.data);

      const payload = {
        title: addressName.trim(),
        description: address,
        map_location: `${mapLocationSource.lat},${mapLocationSource.lng}`,
        province: province.trim(),
        city: city.trim(),
        district: district.trim(),
        street: street.trim(),
        building_number: building.trim(),
        apartment_number: apartment.trim(),
        receiver_name: receiver.trim(),
        receiver_phone: phone.trim(),
        is_active: existingAddresses.length === 0,
        full_address: fullAddress.trim(),
      };

      const res = await fetch(`${base_url}/api/addresses`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("تم إضافة العنوان بنجاح");
        setShowModal(false);
        window.dispatchEvent(new CustomEvent("addressesUpdated"));
        navigate("/my-addresses");
      } else {
        toast.error("حصل خطأ: " + data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("حدث خطأ في الاتصال بالباك إند");
    }
  };

  if (!isLoaded) return (
  <div className="flex justify-center py-10">
        <AppSpinner />
      </div>
  );

  return (
    <div className="relative mx-auto h-svh max-h-svh w-full max-w-3xl overflow-hidden">
      <GoogleMap
        zoom={16}
        center={center}
        mapContainerClassName="h-full w-full"
        onLoad={(map) => (mapRef.current = map)}
        onDragEnd={handleMapStop} // 🔥 هنا التعديل
        options={{ disableDefaultUI: true }}
      />

      {/* 📍 PIN ثابت */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full">
        <img src="/assets/images/pin.svg" className="w-10 h-10" />
      </div>

      {/* 🔍 SEARCH */}
      <input
        ref={searchRef}
        type="text"
        placeholder="عما تبحث ؟"
        className="font-[cairo] text-[12px] absolute top-4 left-4 right-8 p-2 rounded-[29px] shadow border-none bg-[#F2F2F2]"
      />

      {/* شريط سفلي: العنوان + متابعة — داخل الارتفاع المرئي (svh) ومنطقة آمنة للموبايل */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 flex flex-col gap-2 px-4 pb-[max(1rem,env(safe-area-inset-bottom,0px))] pt-2">
        <div className="pointer-events-auto max-h-[30svh] overflow-y-auto rounded bg-white p-3 text-center font-[cairo] text-sm shadow">
          {address}
        </div>
        <button
          type="button"
          onClick={handleOpenManualForm}
          className="pointer-events-auto shrink-0 rounded-[4px] bg-[#F93209] p-3 font-[cairo] text-white"
        >
          متابعة
        </button>
      </div>

      {/* 🔵 Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/45">
          <div
            dir="rtl"
            className="flex max-h-[min(86svh,86vh)] w-full flex-col overflow-hidden rounded-t-[8px] bg-white pt-4 shadow-2xl md:w-[780px]"
          >
            <div className="mb-4 grid shrink-0 grid-cols-[32px_1fr_32px] items-center px-4 md:px-5">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="mr-auto flex h-8 w-8 items-center justify-center rounded-full text-[#1F2937]"
                aria-label="إغلاق"
              >
                <Icon name="X" size={22} />
              </button>

              <h2 className="text-center font-[cairo] text-[16px] font-bold text-[#1F2937]">
                إكمال العنوان
              </h2>

              <span />
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-3 md:px-5">
              <div className="space-y-3 font-[cairo]">
                <div className="space-y-1">
                  <label className="block text-right text-[12px] font-medium text-[#666]">
                    اسم العنوان
                  </label>
                  <input
                    value={addressName}
                    onChange={(e) => setAddressName(e.target.value)}
                    placeholder="مثل : المكتب او العمل او المدرسة والخ"
                    className="w-full rounded-[8px] border border-[#A8A8A8] px-4 py-2 text-right text-[13px] placeholder:text-[#C9C9C9] outline-none ring-0 shadow-none focus:border-[#F93209] focus:outline-none focus:ring-0 focus:shadow-none focus-visible:outline-none"
                  />
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">المحافظة</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                      placeholder="المحافظة"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">المدينة</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      placeholder="المدينة"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">الحي</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      value={district}
                      onChange={(e) => setDistrict(e.target.value)}
                      placeholder="الحي"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">الشارع</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      value={street}
                      onChange={(e) => setStreet(e.target.value)}
                      placeholder="الشارع"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      رقم البناء
                    </label>
                    <input
                      value={building}
                      onChange={(e) => setBuilding(digitsOnly(e.target.value))}
                      placeholder=""
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="off"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      رقم الشقة
                    </label>
                    <input
                      value={apartment}
                      onChange={(e) => setApartment(digitsOnly(e.target.value))}
                      placeholder=""
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="off"
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">اسم المستلم</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      value={receiver}
                      onChange={(e) => setReceiver(e.target.value)}
                      placeholder=""
                      className={manualInputClass}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-right text-[12px] font-medium text-[#666]">
                      <span className="text-[#666]">رقم الهاتف</span>
                      <span className="mr-1 text-[#F93209]">*</span>
                    </label>
                    <input
                      type="tel"
                      dir="rtl"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        setPhoneError("");
                      }}
                      onBlur={() => setPhoneError(validatePhoneNumber(phone) || "")}
                      placeholder="09********"
                      className={`w-full rounded-[8px] border px-4 py-2 text-right text-[13px] outline-none ring-0 shadow-none placeholder:text-[#C9C9C9] focus:border-[#F93209] focus:outline-none focus:ring-0 focus:shadow-none focus-visible:outline-none ${
                        phoneError ? "border-red-500" : "border-[#A8A8A8]"
                      }`}
                    />
                    {phoneError && (
                      <p className="text-right text-[11px] text-red-500">{phoneError}</p>
                    )}
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block text-right text-[12px] font-medium text-[#666]">
                    <span className="text-[#666]">العنوان بالتفصيل</span>
                    <span className="mr-1 text-[#F93209]">*</span>
                  </label>
                  <textarea
                    value={fullAddress}
                    onChange={(e) => setFullAddress(e.target.value)}
                    placeholder=""
                    className="min-h-[115px] w-full resize-none rounded-[8px] border border-[#A8A8A8] p-2 text-right text-[13px] outline-none ring-0 shadow-none focus:border-[#F93209] focus:outline-none focus:ring-0 focus:shadow-none focus-visible:outline-none"
                    rows={4}
                  />
                </div>

                <div className="rounded-full border border-red-100 bg-[#FFF7E9] px-2 py-1 text-center font-[cairo] text-[11px] text-red-500">
                  <div className="flex flex-row-reverse items-center justify-center gap-1.5">
                    <span>
                      إدخال العنوان بشكل مفصل يساعد على وصول الدليفري بشكل أسرع
                    </span>
                    <Icon name="AlertCircle" size={14} color="#EF4444" />
                  </div>
                </div>
              </div>
            </div>

            <div className="shrink-0 border-t border-[#F3F4F6] bg-white px-4 pb-[max(1rem,env(safe-area-inset-bottom,0px))] pt-3 md:px-5">
              <button
                type="button"
                onClick={handleSubmit}
                className="w-full rounded-[6px] bg-[#F93209] py-2.5 font-[cairo] text-[16px] font-bold text-white"
              >
                إضافة
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}